module.exports = __webpack_public_path__ + "img/farming_nr1_1.aa43a827.png";